import { put, debounce, select } from 'redux-saga/effects';

import { makeGetRequest } from 'tools/utilities/ajax';
// eslint-disable-next-line import/no-cycle
import { getBearerToken } from 'store/modules/utils/getBearerToken';
import {
  TYPES, IAccountantLookupSuccess, IAccountantLookupFailure, IAccountantLookup,
} from './actions';

function* fetchAccountantResults(action: IAccountantLookup) {
  const {
    searchTerm,
  } = action.payload;

  try {
    const bearerToken = yield select(getBearerToken);

    const accountantResults = yield makeGetRequest<string[]>('/api/Account/GetAccountants', { searchTerm }, bearerToken);

    // console.log('🤔🤔🤔 searchTerm', searchTerm);
    // console.log('🤔🤔🤔 accountantResults', accountantResults);

    yield put<IAccountantLookupSuccess>({
      type: TYPES.ACCOUNTANT_LOOKUP_SUCCESS,
      payload: {
        accountantResults,
      },
    });
  } catch (error) {
    console.error('error', error);

    yield put<IAccountantLookupFailure>({
      type: TYPES.ACCOUNTANT_LOOKUP_FAILURE,
      payload: {
        error,
      },
    });
  }
}

export function* accountantLookupSaga() {
  yield debounce(500, TYPES.ACCOUNTANT_LOOKUP, fetchAccountantResults);
}
